import { defineStore } from 'pinia'

export const useLoaderStore = defineStore('loader', {
  state: () => ({
    loadingRequestCount: 0
  }),
  getters: {
    isLoading: (state) => state.loadingRequestCount > 0
  },
  actions: {
    startRequest () {
      this.loadingRequestCount++
    },
    endRequest () {
      if (this.loadingRequestCount > 0) {
        this.loadingRequestCount--
      }
    }
  }
})
